import { render, staticRenderFns } from "./purchase-select.vue?vue&type=template&id=cb52a32e"
import script from "./purchase-select.vue?vue&type=script&lang=js"
export * from "./purchase-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports